import * as actionTypes from './actionTypes';
import { parseAuthorities } from '../../util/jwt';

const initialState = {
  isAuthenticated:
    !!localStorage.getItem('accessToken') &&
    !parseAuthorities(localStorage.getItem('accessToken')).includes('ROLE_2FA_SETUP'),
  loginDestination: '/dashboard',
  userId: null,
  authorities: [],
  isLoading: false,
  hasError: false,
  qrCodeUrl2Fa: null,
  secret2Fa: null,
  requires2Fa: false,
  is2FaSetupRequired:
    !!localStorage.getItem('accessToken') &&
    parseAuthorities(localStorage.getItem('accessToken')).includes('ROLE_2FA_SETUP'),
  accessToken: null,

  enable2Fa: {
    hasError: false,
    isLoading: false,
  },

  forgotPassword: {
    hasError: false,
    isLoading: false,
    isSuccess: false,
  },

  resetPassword: {
    hasError: false,
    isLoading: false,
    isSuccess: false,
    hasVerifyError: false,
    isVerifyLoading: false,
    isVerifySuccess: false,
    hasVerifyAuthCodeError: false,
    isVerifyAuthCodeLoading: false,
    isVerifyAuthCodeSuccess: false,
  },

  changePassword: {
    hasError: false,
    isLoading: false,
    isSuccess: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.LOGIN_SUCCESS:
      const authorities = parseAuthorities(action.token); // eslint-disable-line
      const is2FaSetupRequired = authorities.includes('ROLE_2FA_SETUP'); // eslint-disable-line
      return {
        ...state,
        is2FaSetupRequired,
        isAuthenticated: !is2FaSetupRequired,
        hasError: false,
        isLoading: false,
        accessToken: action.token,
        authorities: parseAuthorities(action.token),
      };
    case actionTypes.LOGIN_ERROR:
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    case actionTypes.LOGIN_REQUIRE_2FA:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        requires2Fa: true,
      };
    case actionTypes.LOGOUT:
      return initialState;
    case actionTypes.SET_LOGIN_DESTINATION:
      return {
        ...state,
        loginDestination: action.destination,
      };
    case actionTypes.FETCH_MY_USER_SUCCESS:
      return {
        ...state,
        userId: action.id,
      };
    case actionTypes.FORGOT_PASSWORD:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: true,
        },
      };
    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: false,
          isSuccess: true,
        },
      };
    case actionTypes.FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: false,
          isSuccess: false,
          hasError: true,
        },
      };
    case actionTypes.RESET_PASSWORD:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: true,
        },
      };
    case actionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: false,
          isSuccess: true,
        },
      };
    case actionTypes.RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isLoading: false,
          isSuccess: false,
          hasError: true,
        },
      };

    case actionTypes.CHANGE_PASSWORD:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          isLoading: false,
          isSuccess: true,
        },
      };
    case actionTypes.CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          isLoading: false,
          isSuccess: false,
          hasError: true,
        },
      };

    case actionTypes.VERIFY_TOKEN:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isVerifyLoading: true,
        },
      };
    case actionTypes.VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isVerifyLoading: false,
          isVerifySuccess: true,
        },
      };
    case actionTypes.VERIFY_TOKEN_ERROR:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isVerifyLoading: false,
          isVerifySuccess: false,
          hasVerifyError: true,
          hasError: true,
        },
      };

    case actionTypes.VERIFY_RESET_CODE:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isVerifyAuthCodeLoading: true,
        },
      };
    case actionTypes.VERIFY_RESET_CODE_SUCCESS:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isVerifyAuthCodeLoading: false,
          isVerifyAuthCodeSuccess: true,
        },
      };
    case actionTypes.VERIFY_RESET_CODE_ERROR:
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          isVerifyAuthCodeLoading: false,
          isVerifyAuthCodeSuccess: false,
          hasVerifyAuthCodeError: true,
          hasError: true,
        },
      };

    case actionTypes.INIT_2FA_SUCCESS:
      return {
        ...state,
        qrCodeUrl2Fa: action.qrCodeUrl,
        secret2Fa: action.secret,
      };

    case actionTypes.ENABLE_2FA:
      return {
        ...state,
        enable2Fa: {
          ...state.enable2Fa,
          isLoading: true,
        },
      };
    case actionTypes.ENABLE_2FA_SUCCESS:
      return {
        ...state,
        is2FaSetupRequired: false,
        enable2Fa: {
          ...state.enable2Fa,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.ENABLE_2FA_ERROR:
      return {
        ...state,
        enable2Fa: {
          ...state.enable2Fa,
          isLoading: false,
          hasError: true,
        },
      };

    default:
      return state;
  }
};
